/* eslint-disable indent */
// eslint-disable-next-line import/order
import { makeId } from 'utils/stringHelper';
import createDataContext from './createDataContext';

const reducer = (state, action) => {
  switch (action.type) {
    case 'show':
      return {
        ...state,
        isVisible: true,
        isError: action.payload.isError || false,
        options: action.payload,
      };
    case 'hide':
      return { ...state, isVisible: false, options: null };
    case 'showActionAlert':
      return {
        ...state,
        actionAlerts: [...(state.actionAlerts || []), action.payload],
      };
    case 'hideActionAlert':
      return {
        ...state,
        actionAlerts: (state.actionAlerts || []).filter((x) => x.id !== action.payload),
      };
    default:
      return state;
  }
};

const show = (dispatch) => (text, options) => {
  dispatch({
    type: 'show',
    payload: { text, options },
  });

  setTimeout(() => {
    dispatch({ type: 'hide' });
  }, options?.duration || 3000);
};

const error =
  (dispatch) =>
  ({ text, options }) => {
    dispatch({
      type: 'show',
      payload: { text, ...{ isError: true, ...options } },
    });

    setTimeout(() => {
      dispatch({ type: 'hide' });
    }, options?.duration || 3000);
  };

const success =
  (dispatch) =>
  ({ text, options }) => {
    dispatch({
      type: 'show',
      payload: { text, ...{ isError: false, ...options } },
    });

    setTimeout(() => {
      dispatch({ type: 'hide' });
    }, options?.duration || 3000);
  };

const actionWarning =
  (dispatch) =>
  ({ text }) => {
    dispatch({
      type: 'showActionAlert',
      payload: { id: makeId(10), text, type: 'warning' },
    });
  };

const hideAction =
  (dispatch) =>
  ({ id }) => {
    dispatch({
      type: 'hideActionAlert',
      payload: id,
    });
  };

const hide = (dispatch) => () => {
  dispatch({ type: 'hide' });
};

const initialData = {
  isVisible: false,
  isError: false,
  options: null,

  actionAlerts: [],
};

export const { Context, Provider } = createDataContext(
  reducer,
  {
    show,
    error,
    success,
    hide,

    actionWarning,
    hideAction,
  },
  { ...initialData },
  'alertController',
);
